"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFacebookMin(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M13.744 22v-9.123h3.067l.456-3.554h-3.523v-2.27c0-1.028.286-1.731 1.761-1.731h1.885V2.139C17.066 2.093 15.946 2 14.648 2c-2.72 0-4.573 1.66-4.573 4.705V9.33H7v3.554h3.075V22h3.669z"
  }));
}

var _default = SvgFacebookMin;
exports.default = _default;